module.exports = __webpack_public_path__ + "static/media/js-grid.21f03a4a.png";